<template>
    <div>
        <div class="alert-warning mb-2" v-if="customer && customer.doc_type === 'cnpj'">
            Pedidos feitos com seu CNPJ só podem ser enviados para o mesmo endereço cadastrado na
            receita.
        </div>

        <Alert :alert="alert" />

        <div class="flex-grid">
            <div v-if="isLoading" class="d-flex flex-spaced-fixed">
                <div class="cr-spinner-small"></div>
                <p>{{ $t('waitMoment') }}...</p>
            </div>

            <AddressEdit
                v-else-if="addressToEdit"
                :customer-id="customer.id"
                :customer-ddi="customer.ddi"
                :edit-address="addressToEdit"
                :confirm-label="$t('_address.selectAndDeliverHere')"
                @cancel="onEditCancel"
                @error="onEditError"
                @success="onEditSuccess"
            />

            <template v-else>
                <div
                    :class="{ 'flex-xs-12 flex-sm-9 flex-md-8 summarize-address': summarize }"
                    class="flex-xs-12"
                >
                    <div v-show="!summarize" class="mb flex-grid">
                        <div class="flex-xs-10 flex-sm-9">
                            <label class="my-2 d-block">{{ $t('_address.selectOrCreate') }}:</label>
                        </div>
                        <div class="flex-xs-2 flex-sm-3">
                            <button
                                class="btn btn-light ml-auto btn-sm pos-absolute pos-right"
                                @click.prevent.stop="createAddress()"
                            >
                                {{ $t('_address.createNew') }}
                            </button>
                        </div>
                    </div>

                    <ul class="checkout-options pt-1">
                        <li
                            v-for="address in addresses"
                            v-if="!summarize || selectedAddress === address"
                            :class="{
                                'no-pointer-events': summarize,
                                'cr-card mb-2 pl-2': !summarize,
                            }"
                        >
                            <input
                                :id="`address-${address.address_id}`"
                                :checked="selectedAddress === address && activeStep > STEP_ADDRESS"
                                v-if="!summarize"
                                class="cr-radio"
                                type="radio"
                            />
                            <label
                                :for="`address-${address.address_id}`"
                                :class="{ 'pl-0': summarize }"
                                @click="selectAddress(address)"
                            >
                                <div
                                    :class="{ 'option-address': !summarize }"
                                    class="checkout-option-content ml-2"
                                >
                                    <p>
                                        {{ $t('_address.recipient') }}:
                                        <strong>{{ address.full_name }}</strong>
                                        <span v-if="address.alias"
                                            >&nbsp;({{ address.alias }})</span
                                        >
                                    </p>
                                    <p>
                                        {{ address.address_1 }}
                                        <span
                                            v-if="
                                                address.city != 'Brasília' &&
                                                !(address.type_id == 1 && address.number == 0)
                                            "
                                            >, {{ address.number }}</span
                                        >
                                        <span
                                            v-if="
                                                address.additional_info &&
                                                address.additional_info != ''
                                            "
                                            >/ {{ address.additional_info }}</span
                                        >
                                        <br />
                                        {{ address.address_2 }} - {{ address.city }}
                                        {{ address.uf }} - CEP
                                        {{ address.zip_code }}
                                    </p>
                                </div>
                                <div
                                    class="flex-grid pos-absolute pos-right mr-2 edit-address-icons h-full"
                                    style="margin-top: 25px"
                                >
                                    <a
                                        v-if="!summarize"
                                        @click.prevent.stop="editAddress(address)"
                                        class="flex-xs-6"
                                        ><i class="icon-cr icon-more"></i
                                    ></a>
                                    <a
                                        v-if="!summarize"
                                        @click.prevent.stop="setAddressToDelete(address)"
                                        class="flex-xs-6"
                                        ><i class="icon-cr icon-trash"></i
                                    ></a>
                                </div>
                            </label>
                        </li>
                    </ul>
                </div>
                <div class="hidden-xs-down flex-sm-3 flex-md-4 mt-4 text-right" v-if="summarize">
                    <a
                        v-show="activeStep > STEP_ADDRESS"
                        class="btn btn-light btn-sm"
                        @click="goToStep(STEP_ADDRESS)"
                    >
                        {{ $t('toChange') }}
                    </a>
                </div>
            </template>

            <ConfirmationModal
                :loading="deleting"
                :show="addressToDelete"
                @no="addressToDelete = null"
                @yes="deleteAddress"
            >
                <p v-if="addressToDelete">
                    {{ $t('_address.areSureDelete') }}<br />
                    <strong> "{{ addressToDelete.alias }}" </strong>?
                </p>
            </ConfirmationModal>
        </div>
    </div>
</template>

<script>
    import BaseCheckoutAddress from './common/BaseCheckoutAddress.vue';
    import store from '../../script/store/checkout';

    export default {
        name: 'CheckoutAddress',
        extends: BaseCheckoutAddress,

        methods: {
            goToStep(step) {
                store.step.goTo(step);
            },
        },
    };
</script>
